import { useSelector } from "react-redux";

export default function useReplaceNumChar() {

    const { lang } = useSelector(state => state.translate);

    return (num) => {
        let char;
        switch (Number(num)) {
            case 1:
                char = lang === 'en' ? '1st' : "א";
                break;
            case 2:
                char = lang === 'en' ? '2nd' : "ב";
                break;
            case 3:
                char = lang === 'en' ? '2rd' : "ג";
                break;
            case 4:
                char = lang === 'en' ? '4th' : "ד";
                break;
            case 5:
                char = lang === 'en' ? '5th' : "ה";
                break;
            case 6:
                char = lang === 'en' ? '6th' : "ו";
                break;
            case 7:
                char = lang === 'en' ? '7th' : "ז";
                break;
            case 8:
                char = lang === 'en' ? '8th' : "ח";
                break;
            case 9:
                char = lang === 'en' ? '9th' : "ט";
                break;
            case 10:
                char = lang === 'en' ? '10th' : "י";
                break;
            case 11:
                char = lang === 'en' ? '11th' : "יא";
                break;
            case 12:
                char = lang === 'en' ? '12th' : "יב";
                break;
            default:
                return null
        }
        return char;
    }
}